import { getErrorMessage } from '@mairistem/finances-utils';
import CODE_BHM from '../../../constants/mouvements/codeBHM';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauDenumeroterAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	private isRejet: boolean;

	constructor(options: BaseLiquidationOptions & { isRejet?: boolean } = null) {
		super(options);
		this.label = options?.isRejet
			? 'Annuler l’archivage de ce bordereau de rejet'
			: 'Dénuméroter';
		this.type = BordereauActionType.DENUMEROTER;
		this.isRejet = options?.isRejet;
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauDenumeroterModal: {
				visible: true,
				isArchive: this.isRejet,
			},
		},
	});

	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.UPDATE,
		result: new Promise((resolve, reject) => {
			updateBordereau(
				{
					...bordereau,
					codeBHM: CODE_BHM.VALUE.BROUILLARD,
					etat: '',
				},
				new URLSearchParams({ withJournaux: 'true' }),
			)
				.then((updatedBordereau) => {
					resolve(updatedBordereau);
				})
				.catch((e) => {
					reject(
						Error(
							getErrorMessage(e, 'Erreur lors de la modification du bordereau'),
						),
					);
				});
		}),
		shouldRefreshChildren: true,
	});
}

export default BordereauDenumeroterAction;
